import { loadRecaptcha } from '@partials/UI/form/modules/recaptcha/recaptchaLoader';

// Функция инициализации наблюдателей за формой
function initFormObservers() {
    const staticForm = document.querySelector('.static_form');

    if (!staticForm) {
        // console.warn('⚠️ Статическая форма не найдена на странице');
        return;
    }

    // console.log('✅ Статическая форма найдена, настраиваем наблюдатели');

    let captchaTriggered = false; // Флаг для предотвращения двойной загрузки

    // Обёртка для loadRecaptcha с защитой от повторных вызовов
    const triggerCaptchaLoad = () => {
        if (captchaTriggered) return;
        captchaTriggered = true;
        
        // console.log('🎯 Триггер сработал: загружаем reCAPTCHA');
        loadRecaptcha().catch(error => {
            console.error('Ошибка при загрузке reCAPTCHA:', error);
            captchaTriggered = false; // Сбрасываем при ошибке
        });
    };

    // Вариант 1: Наведение мыши (для десктопа)
    staticForm.addEventListener('mouseenter', triggerCaptchaLoad, { once: true });

    // Вариант 2: Тач-событие (для мобильных)
    staticForm.addEventListener('touchstart', triggerCaptchaLoad, { once: true, passive: true });

    // Вариант 3: Intersection Observer (скролл к форме)
    if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    // console.log('👁️ Форма появилась в области видимости');
                    triggerCaptchaLoad();
                    observer.unobserve(staticForm);
                }
            });
        }, { 
            rootMargin: '200px', // Загружаем заранее
            threshold: 0.01 // Минимальное пересечение
        });

        observer.observe(staticForm);
        // console.log('👁️ IntersectionObserver активирован для формы');
    } else {
        console.warn('⚠️ IntersectionObserver не поддерживается');
    }
}

// Запуск после загрузки DOM
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFormObservers);
} else {
    // DOM уже загружен
    initFormObservers();
}